import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";

export const purchaseGiftCardLanguages = {
  navMenueLinkText: "Purchase Deposit",
  pageTitle: "Winnipeg Jets Deposit",
  mainCardTitle: "Purchase Deposit",
  amountTitle: "Deposit Amount",
  checkoutCardTitle: "Purchase Deposit",
  checkoutItemTitle: "Deposit Amount",
};

export const purchaseSeatsLanguages = {
  purchaseSeatTabTitle: "Create Game Pack",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Click Get Started",
    description:
      "Click Get Started on your desktop, laptop, or mobile device to begin.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Games",
    description:
      "Select the games you wish to attend based on the amount of credit you have available.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Connect your Winnipeg Jets account using our secure Ticketmaster login. ",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available by logging into your TN Ticket Central Account
        Manager at{" "}
        <Link
          href={"https://am.ticketmaster.com/tnse/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          https://am.ticketmaster.com/tnse/
        </Link>
        . Reach out to{" "}
        <Link
          href={"mailto:ticketsales@winnipegjets.com"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          ticketsales@winnipegjets.com
        </Link>{" "}
        for any questions
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Winnipeg Jets Game Pack work?",
    description:
      "The Winnipeg Jets Flex allows fans to select any seat to any game. Simply log into your Winnipeg Jets Flex Account manager and select games.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory. ",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your TN Ticket Central
        Account Manager at{" "}
        <Link
          href={"https://am.ticketmaster.com/tnse/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          https://am.ticketmaster.com/tnse/
        </Link>
        .
      </>
    ),
  },
  {
    title: "My tickets are not available once I arrive at the checkout.",
    description:
      "There are some instances where multiple games select the same ticket and attempt to checkout at the same time. Unfortunately, this will cause one fan to check out with tickets that are no longer available for purchase and will require the fan to select a different seat. To avoid this scenario, please check out with one seat selection at a time during peak demand windows, including initial game selection and immediately prior to game start. ",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
